<form (ngSubmit)="save()" [formGroup]="form" class="modal-wrapper">
    <div class="modal-header">
        <h2 class="modal-title">Add contract</h2>
        <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">
        <div class="form-group m-b-2">
            <label>Employee</label>
            <div>{{ employee?.firstName }} {{ employee?.lastName }}</div>
        </div>

        <div class="employee-picker m-b-3" *ngIf="scope === 'CLIENT'">
            <div class="modal-toolbar">
                <input
                    type="text"
                    placeholder="Search project..."
                    name="filterText"
                    [ngModelOptions]="{ standalone: true }"
                    [(ngModel)]="filterText" />
                <span class="result-count">{{ filteredProjects.length }} found</span>
                <span class="result-count">{{ selectedProjectIds.length }} selected</span>
            </div>

            <div class="table__overflow">
                <table class="table-view">
                    <tr>
                        <th class="td-small"></th>
                        <th>Project</th>
                    </tr>
                    <tr *ngFor="let project of filteredProjects" class="pointer" (click)="toggleProject(project)">
                        <td>
                            <input type="checkbox" [checked]="isProjectSelected(project)" />
                        </td>
                        <td>{{ project.title }}</td>
                    </tr>
                </table>
            </div>
        </div>

        <div class="row">
            <div class="form-group m-b-2 required">
                <label for="pricePerHour">Price per hour</label>
                <small class="form-error" *ngIf="form.get('pricePerHour').invalid && form.get('pricePerHour').touched">Price per hour is required...</small>
                <input type="number" id="pricePerHour" formControlName="pricePerHour" />
            </div>
        </div>

        <div class="row">
            <div class="form-group m-b-2 required">
                <label for="effectiveFrom">Effective from (date)</label>
                <small class="form-error" *ngIf="form.get('effectiveFrom').invalid && form.get('effectiveFrom').touched">Effective date is required...</small>
                <input type="date" id="effectiveFrom" formControlName="effectiveFrom" />
            </div>
            <div class="form-group m-b-2">
                <label for="effectiveTo">Effective to (date)</label>
                <input type="date" id="effectiveTo" formControlName="effectiveTo" />
            </div>
        </div>

        <div class="row">
            <div class="form-group m-b-2">
                <label for="contractFile">Contract (optional)</label>
                <app-file-upload formControlName="contractFile" type="file"></app-file-upload>
            </div>
        </div>

        <div class="row">
            <div class="form-group m-b-2">
                <label for="poNumber">Purchase order (PO)</label>
                <input type="text" id="poNumber" formControlName="poNumber" />
            </div>
            <div class="form-group m-b-2">
                <label for="sesNumber">SES / invoicing approval</label>
                <input type="text" id="sesNumber" formControlName="sesNumber" />
            </div>
        </div>

        <div class="row">
            <div class="form-group m-b-2">
                <label for="contractAgreementNumber">Contract / MSA number</label>
                <input type="text" id="contractAgreementNumber" formControlName="contractAgreementNumber" />
            </div>
        </div>

        <div class="row">
            <div class="form-group m-b-2">
                <label for="freeText">Invoice free text</label>
                <textarea id="freeText" rows="3" formControlName="freeText"></textarea>
            </div>
        </div>
    </div>

    <div class="modal-footer">
        <button
            type="submit"
            class="button button--primary"
            [disabled]="form.invalid || (scope === 'CLIENT' && selectedProjectIds.length === 0) || loading"
            [ngClass]="{ 'button--loading': loading }">
            Add
        </button>
        <button type="button" class="button button--outline" (click)="activeModal.dismiss()">Cancel</button>
    </div>
</form>
